import React from 'react'
import PortfolioModalImageGrid from './PortfolioModalImageGrid';
import PortfolioModalImageSingle from './PortfolioModalImageSingle';
import PortfolioModalRightNoImages from './PortfolioModalRightNoImages';
import IImage from './IImage';
import ILabels from './ILabels';
import IPhotographer from './IPhotographer';

interface Props {
    setFullscreenMode: () => void;
    images: IImage[];
    currentImage: number;
    setCurrentImage: () => void;
    onClose: () => void;
    onNextImage: () => void;
    onBeforeImage: () => void;
    setGridMode: () => void;
    gridMode: boolean;
    screenWidth: number;
    photographer: IPhotographer;
    labels: ILabels;
};

const PortfolioModalRight: React.FunctionComponent<Props> = ({ setFullscreenMode, images, currentImage, setCurrentImage, onNextImage, onBeforeImage, gridMode, setGridMode, screenWidth, photographer, labels }) => {

    return (
        <>
            {images.length ?
                <>
                    {gridMode || screenWidth < 1200 ?
                        <PortfolioModalImageGrid
                            images={images}
                            setGridMode={setGridMode}
                            setCurrentImage={setCurrentImage}
                            screenWidth={screenWidth}
                        />
                        :
                        <PortfolioModalImageSingle
                            images={images}
                            currentImage={currentImage}
                            setFullscreenMode={setFullscreenMode}
                            onNextImage={onNextImage}
                            onBeforeImage={onBeforeImage}
                            setGridMode={setGridMode}
                        />
                    }
                </> :
                <PortfolioModalRightNoImages photographer={photographer} labels={labels} />
            }
        </>
    )
}

export default PortfolioModalRight